document.addEventListener("DOMContentLoaded", function () {

    const wrapper = document.getElementById("product-color-wrapper");
    if (!wrapper) return;

    const backgrounds = {
        "Grey": "#E5E5E5",
        "Matt Black": "#1d1d1d",
        "Pastel Blue": "#DDF3FF",
        "Pastel Pink": "#FFE2EC"
    };

    function updateBackground() {

        // Kalles selected swatch
        const checked = document.querySelector(
            '.t4s-swatch input:checked, input[name^="options"]:checked'
        );

        if (!checked) return;

        const color = checked.value;

        wrapper.style.background = backgrounds[color] || "#ffffff";

        if (color === "Matt Black") {
            wrapper.style.color = "#fff";
        } else {
            wrapper.style.color = "#111";
        }
    }

    updateBackground();

    document.addEventListener("change", function () {
        setTimeout(updateBackground, 100);
    });

});